// extracted by mini-css-extract-plugin
module.exports = {"Large":"RandomCode_Large__2bpV0"};